import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { AxiosWrapper } from 'services/AxiosWrapper';
import { ItineraryManagerApiService } from 'services/ItineraryManagerApi';

export const useOtpQueries = (
  itineraryManagerApi: ItineraryManagerApiService<AxiosWrapper<AxiosInstance>>,
  itemUuid: string,
  accessuuid: string | null,
  enabled: boolean = true,
) => {
  return {
    checkIsOtpRequired: useQuery({
      queryKey: ['checkIsOtpRequired', itemUuid, accessuuid],
      queryFn: async () => {
        if (!itemUuid) {
          return;
        }
        return itineraryManagerApi.checkIsOtpRequired(itemUuid, accessuuid);
      },
      enabled,
    }),
  };
};
